import React from "react";
import { injectIntl } from "react-intl";

// HOC
// import AppHOC from "../hoc/AppHOC";

import { connect } from "react-redux";
import ModalPortal from "../components/modals/ModalPortal";
import ErrorPopup from "../components/popups/ErrorPopup";

export const GenericError = (props) => {
  if (!props.app.errorPopup) {
    return null;
  }

  return (
    <ModalPortal>
      <ErrorPopup
        title={props.intl.formatMessage({ id: "sthWrong" })}
        text={props.intl.formatMessage({ id: "willBeFixed" })}
        iconId="infoFull"
        reloadPageBtn
      />
    </ModalPortal>
  );
};

const mapStateToProps = state => ({
  app: state.app,
});

export default injectIntl(connect(mapStateToProps)(GenericError));
